import { client } from "../client";
import { AdminSettings } from "../types/adminsettings.types";

export const updateAdminSettingsMutation = async ({
	settings,
}: {
	settings: AdminSettings;
}) => {
	const response = await client.patch<AdminSettings>(
		"/admin/settings",
		settings,
	);
	return response.data;
};
